// types
import { ISP_CoolingGenerator } from './types'
// components
import { ChildrenView } from '../../components/ChildrenView'
import { OperatorPanelWrapperWithChildren } from '../../components/Layout';
import { CoolingCoil3D } from '../SP_CoolingCoil/CoolingCoil3D';
import { Badge } from 'baseui/badge';
import { FormattedMessage } from 'react-intl';


export function OperatorPanel(props: ISP_CoolingGenerator) {

    return (
        <OperatorPanelWrapperWithChildren resourceGroupId={props.resourceGroupId} objectId={props.id}
            statusContent={<>
                <CoolingCoil3D active={props.isOn} width={100} height={100}></CoolingCoil3D>
                {props.isOn && <Badge hierarchy='secondary' color='accent' content={<FormattedMessage id="SubPlants.COOLING" defaultMessage="COOLING" />} />}
                {!props.isOn && <Badge hierarchy='secondary' color='primary' content={<FormattedMessage id="Devices.OFF" defaultMessage="Off" />} />}
            </>}>
        </OperatorPanelWrapperWithChildren>
    );
}

